@if (!loadingDialog()) {
  <h1 mat-dialog-title>Weet je zeker dat je een incasso wilt aanmaken?</h1>
}
@if (!loadingDialog()) {
  <div mat-dialog-content>
    Dit genereert, per Buurtvervoerder, een SEPA bestand van deze maand!<br />
    <form [formGroup]="sepaForm" autocomplete="off">
      @for (organisation of organisations(); track organisation) {
        <div>
          <mat-checkbox [formControlName]="organisation.formControl">{{ organisation.name }}</mat-checkbox>
        </div>
      }
      <mat-form-field>
        <mat-label>Maand</mat-label>
        <mat-select formControlName="month">
          @for (month of months(); track month) {
            <mat-option [value]="month">
              {{ month.name }}
              {{ month.period }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
  </div>
}
@if (!loadingDialog()) {
  <div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Annuleren</button>
    <button mat-flat-button (click)="createSepa()" [class.spinner]="loading()" [disabled]="!sepaForm.valid">
      Incasso aanmaken
    </button>
  </div>
}
